import React, { useState, useEffect } from 'react';
import { Form, OverlayTrigger, Popover, Col, Row, ProgressBar, Modal, Alert } from 'react-bootstrap';
import { Segment } from "semantic-ui-react";
import Amplify, { Storage, API, Auth } from 'aws-amplify';
import { TextField } from '@material-ui/core';
import { message, Upload, Space, Button, notification, Skeleton } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import NavBar from './NavBar'
import '../App.css';
import { useHistory, Link } from "react-router-dom";


export default function Loading() {

	return (
		<div className="MyAll">
			<div className="MyNav">
				<Row >
					<Col></Col>
					<Col className="MyContainer1">
						<NavBar />
					</Col>
					<Col></Col>
				</Row>
			</div>
			{/* <div style={{height:"2em"}} /> */}
			<div className="MyBody">
				<Row >
					<Col></Col>
					<Col className="MyContainer1">
						<Segment basic>
							<Skeleton active loading />
						</Segment>
						<div style={{ height: "20px" }} />
					</Col>
					<Col></Col>
				</Row>
			</div>

			

		</div>
	)
}
